<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body" v-if="loaded">
            <div class="small-box text-center text-justify" v-if="!error">
                <h3>{{$t("Aitah, tellimus on esitatud!")}}</h3>
                <p>{{$t("Kusimuste korral helista")}} 
                    <a href="tel:+3726144100"><b>+372&nbsp;614&nbsp;4100</b></a> 
                    {{$t("voi kirjuta")}}
                    <a href="mailto:kuulutused@ohtulehtkirjastus.ee">kuulutused@ohtulehtkirjastus.ee</a></p>
                <br>
                <div class="text-uppercase p-1">
                    <a href="#adType"> {{$t("Sisesta veel kuulutusi")}} <i
                            class="fa fa-xs fa-angle-right"></i></a>
                </div>
                <div class="text-uppercase p-1">
                    <a href="https://www.ohtuleht.ee/"> {{$t("Ohtulehte uudiseid lugema")}}
                        <i class="fa fa-xs fa-angle-right"></i></a>
                </div>
            </div>
            <div class="small-box text-center" v-else-if="error==='expired'">
                <div class="alert alert-danger">
                    <h3>{{$t("Sessioon on aegunud, sisesta kuulutus uuesti!")}}</h3>
                </div>
                <p>{{$t("Kusimuste korral helista")}} 
                    <a href="tel:+3726144100"><b>+372 614 4100</b></a> 
                    {{$t("voi kirjuta")}}
                    <a href="mailto:kuulutused@ohtulehtkirjastus.ee">kuulutused@ohtulehtkirjastus.ee</a></p>
                <br>
                <div class="text-uppercase p-1"><a href="#adType"> {{$t("Sisesta veel kuulutusi")}} <i
                        class="fa fa-xs fa-angle-right"></i></a></div>
                <div class="text-uppercase p-1"><a href="https://www.ohtuleht.ee/"> {{$t("Ohtulehte uudiseid lugema")}}
                    <i class="fa fa-xs fa-angle-right"></i></a></div>
            </div>
            <div class="small-box text-center" v-else-if="error==='payment_failed'">
                <div class="alert alert-danger">
                    <h3>{{$t("Makse ebaonnestus")}}!</h3>
                </div>
                <p>{{$t("Kusimuste korral helista")}} 
                    <a href="tel:+3726144100"><b>+372 614 4100</b></a> 
                    {{$t("voi kirjuta")}}
                    <a href="mailto:kuulutused@ohtulehtkirjastus.ee">kuulutused@ohtulehtkirjastus.ee</a></p>
                <br>
                <div class="text-uppercase p-1"><a href="#adType"> {{$t("Sisesta veel kuulutusi")}} <i
                        class="fa fa-xs fa-angle-right"></i></a></div>
                <div class="text-uppercase p-1"><a href="https://www.ohtuleht.ee/"> {{$t("Ohtulehte uudiseid lugema")}}
                    <i class="fa fa-xs fa-angle-right"></i></a></div>
            </div>
            <div class="small-box text-center" v-else>
                <div class="alert alert-danger">
                    <h3>ERROR! Tundmatu viga!</h3>
                </div>
                <p>{{$t("Kusimuste korral helista")}} 
                    <a href="tel:+3726144100"><b>+372 614 4100</b></a> 
                    {{$t("voi kirjuta")}}
                    <a href="mailto:kuulutused@ohtulehtkirjastus.ee">kuulutused@ohtulehtkirjastus.ee</a></p>
                <br>
                <div class="text-uppercase p-1"><a href="#adType"> {{$t("Sisesta veel kuulutusi")}} <i
                        class="fa fa-xs fa-angle-right"></i></a></div>
                <div class="text-uppercase p-1"><a href="https://www.ohtuleht.ee/"> {{$t("Ohtulehte uudiseid lugema")}}
                    <i class="fa fa-xs fa-angle-right"></i></a></div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onActivated } from 'vue';
import axios from 'axios';

const error = ref(null);
const loaded = ref(false);

const fetchSessionInfo = async () => {
  try {
    const response = await axios.get("/session-info");
    if (response.data.error) {
      error.value = response.data.error;
    }
  } catch (e) {
    error.value = 'unknown';
    console.error(e);
  } finally {
    loaded.value = true;
  }
}

onMounted(fetchSessionInfo);
onActivated(fetchSessionInfo);
</script>
